import { createSlice } from '@reduxjs/toolkit';
const serviceFee: any = {};
const filters: any = {};

const serviceFeesReducer = createSlice({
	name: 'serviceFees',
	initialState: {
		isLoading: false,
		serviceFees: [],
		serviceFee,
		filters,
	},
	reducers: {
		setServiceFeesIsLoading: (state) => {
			state.isLoading = true;
		},
		resetServiceFeesIsLoading: (state) => {
			state.isLoading = false;
		},
		setServiceFees: (state, action) => {
			state.serviceFees = action.payload;
		},
		resetServiceFees: (state) => {
			state.serviceFees = [];
		},
		setServiceFee: (state, action) => {
			state.serviceFee = action.payload;
		},

		resetServiceFee: (state) => {
			state.serviceFee = {};
		},

		setServiceFeesFilters: (state, action) => {
			state.filters = action.payload;
		},

		resetServiceFeesFilters: (state) => {
			state.filters = {};
		},
	},
});
export const {
	setServiceFeesIsLoading,
	resetServiceFeesIsLoading,
	setServiceFee,
	resetServiceFee,
	setServiceFees,
	resetServiceFees,
	setServiceFeesFilters,
	resetServiceFeesFilters,
} = serviceFeesReducer.actions;
export default serviceFeesReducer.reducer;
